import React from 'react';
import { Box, Typography, Paper, Grid, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';

const ViewContract = () => {
  const location = useLocation();
  const contractDetails = location.state || {};

  const handleConfirm = () => {
    // Save contract to database and generate PDF logic here
    alert('Contrato criado com sucesso!');
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Paper sx={{ padding: 3, maxWidth: 800, margin: 'auto' }} elevation={3}>
        <Typography variant="h4" component="h1" gutterBottom>
          CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE DESENVOLVIMENTO DE SOFTWARE
        </Typography>
        <Typography variant="body1" gutterBottom>
          Pelo presente instrumento particular, as partes:
        </Typography>

        <Typography variant="h6" gutterBottom>
          Contratante:
        </Typography>
        <Typography variant="body1"><strong>Nome:</strong> {contractDetails.contractorName}</Typography>
        <Typography variant="body1"><strong>CPF/CNPJ:</strong> {contractDetails.contractorCPF}</Typography>
        <Typography variant="body1"><strong>Email:</strong> {contractDetails.contractorEmail}</Typography>

        <Typography variant="h6" gutterBottom>
          Contratado:
        </Typography>
        <Typography variant="body1"><strong>Nome:</strong> {contractDetails.contractedName}</Typography>
        <Typography variant="body1"><strong>CPF/CNPJ:</strong> {contractDetails.contractedCPF}</Typography>
        <Typography variant="body1"><strong>Email:</strong> {contractDetails.contractedEmail}</Typography>

        <Typography variant="h6" gutterBottom>
          1. OBJETO DO CONTRATO
        </Typography>
        <Typography variant="body1" gutterBottom>
          Este contrato tem por objeto a prestação de serviços de desenvolvimento de software, conforme descrito abaixo:
        </Typography>
        <Typography variant="body1" gutterBottom>
          {contractDetails.object}
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. ESCOPOS E RESPONSABILIDADES
        </Typography>
        <Typography variant="body1" gutterBottom>
          O <strong>Contratado</strong> se compromete a entregar os seguintes itens como parte do projeto:
        </Typography>
        <Typography variant="body1" gutterBottom>
          {contractDetails.scope}
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. PRAZOS E CRONOGRAMA
        </Typography>
        <Typography variant="body1" gutterBottom>
          O <strong>Contratado</strong> se compromete a seguir o cronograma acordado:
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Prazo total do projeto:</strong> {contractDetails.deadline} dias úteis.
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Entrega intermediária:</strong>
        </Typography>
        <Typography variant="body1" gutterBottom>
          {contractDetails.intermediateDeliveries}
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. CONDIÇÕES DE PAGAMENTO
        </Typography>
        <Typography variant="body1" gutterBottom>
          O valor total do projeto será de R$ {contractDetails.totalValue}, com pagamento parcelado nas seguintes condições:
        </Typography>
        <Typography variant="body1" gutterBottom>
          {contractDetails.paymentTerms}
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. REVISÕES E AJUSTES
        </Typography>
        <Typography variant="body1" gutterBottom>
          O <strong>Contratante</strong> terá direito a até <strong>3 rodadas de ajustes</strong> durante a fase de testes. Ajustes adicionais ou alterações fora do escopo inicial serão cobrados à parte, no valor de R$ 100,00 por hora.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. RESCISÃO E GARANTIAS
        </Typography>
        <Typography variant="body1" gutterBottom>
          Este contrato pode ser rescindido por qualquer uma das partes, nas seguintes condições:
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Pelo Contratante:</strong> Caso o <strong>Contratado</strong> não entregue o produto dentro do prazo acordado, após aviso prévio de 15 dias.
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Pelo Contratado:</strong> Caso o <strong>Contratante</strong> não efetue os pagamentos conforme acordado, após 15 dias de atraso.
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Garantias:</strong> O <strong>Contratado</strong> se compromete a corrigir quaisquer erros ou bugs no sistema dentro de <strong>30 dias</strong> após a entrega final. Ajustes fora do escopo ou adicionais serão cobrados à parte.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7. OBRIGAÇÕES DAS PARTES
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Do Contratante:</strong>
        </Typography>
        <Typography variant="body1" gutterBottom>
          - Fornecer todas as informações necessárias para a realização do projeto, incluindo conteúdo, logotipos, materiais de marketing, etc.
        </Typography>
        <Typography variant="body1" gutterBottom>
          - Efetuar os pagamentos conforme estipulado.
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Do Contratado:</strong>
        </Typography>
        <Typography variant="body1" gutterBottom>
          - Entregar o trabalho de acordo com o escopo e prazos estabelecidos.
        </Typography>
        <Typography variant="body1" gutterBottom>
          - Fornecer suporte pós-entrega para correção de bugs durante o período de garantia.
        </Typography>

        <Typography variant="h6" gutterBottom>
          8. DISPOSIÇÕES GERAIS
        </Typography>
        <Typography variant="body1" gutterBottom>
          Este contrato é regido pelas leis brasileiras. Em caso de litígio, as partes concordam em resolver a disputa por meio de mediação ou arbitragem, se necessário.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Assinaturas:
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Contratante:</strong> ______________________
        </Typography>
        <Typography variant="body1" gutterBottom>
          Data: ____/____/______
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Contratado:</strong> ______________________
        </Typography>
        <Typography variant="body1" gutterBottom>
          Data: ____/____/______
        </Typography>

        <Box sx={{ marginTop: 3 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            fullWidth
            sx={{ padding: 1.5 }}
          >
            Confirmar Contrato
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ViewContract;